// Module initialisation for all of our browser bundles

/**
 * Load libraries required to make the page render.
 */
export const init = () => {
  require("tl-theme-bundle"); // CSS bundle
  require("airbnb-js-shims"); // https://github.com/airbnb/js-shims
  require("react");
  require("react-dom");
  require("./cssVarsPonyfill"); // Enable use of --var in CSS for IE11 and others
  require("./init"); // Shared client/server bundle initialisation

  performance.mark("init");
}

/**
 * Load non-critical libraries after the initial server render
 */
export const initAfterRender = () => {
  require("lazysizes"); // Lazyload images
  require("./lazysizesConfig"); // Lazyload JS API configuration
  require("react-dates/initialize"); // Airbnb datepicker
};
